<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t("survey.surveys") }}</li>
          </ul>
        </nav>
      </div>

      <div class="section-header mb-lg-2 border-0 uk-flex-middle">
        <div class="section-header-left">
          <h2 class="uk-heading-line text-left">
            <span> {{ $t("survey.list") }} </span>
          </h2>
        </div>
        <div class="section-header-right">
          <router-link :to="{ name: 'company.survey.add' }">
            <button class="btn btn-default" type="button" aria-expanded="false"
              :disabled="!$hasPermission('create_survey')"
              :style="{ cursor: !$hasPermission('create_survey') ? 'not-allowed' : 'pointer' }">
              <i class="uil-plus"></i> {{ $t("survey.add") }}
            </button>
          </router-link>
        </div>
      </div>

      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <!-- Card header -->
        <div class="card-header actions-toolbar border-0">
          <div class="d-flex justify-content-between">
            <!-- <h4 class="d-inline-block mb-0"></h4> -->
            <!-- <div>
              <a
                href="#"
                class="btn btn-icon btn-hover btn-circle"
                aria-expanded="false"
              >
                <i class="uil-search"></i>
              </a>
              <div
                class="uk-drop"
                uk-drop="mode: hover; pos: right-center; offset: 0"
                style="left: 91px; top: 159.297px"
              >
                <form class="uk-search uk-search-navbar uk-width-1-1">
                  <input
                    class="uk-search-input shadow-0 uk-form-small"
                    type="search"
                    v-model="filter.search"
                    :placeholder="$t('general.search')"
                  />
                </form>
              </div>
            </div> -->
            <div class="uk-search uk-search-navbar">
              <i class="uil-search position-absolute"></i>
              <input class="uk-search-input shadow-0 uk-form-small" type="search" v-model="filter.search"
                :placeholder="$t('general.search')" />
            </div>
            <div class="d-flex">
              <!-- Shorting -->
              <a href="#" class="btn btn-icon btn-hover btn-circle" :uk-tooltip="$t('filters.sort_list')" title=""
                aria-expanded="false">
                <i class="uil-list-ui-alt"></i>
              </a>
              <div uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up" class="uk-dropdown">
                <ul class="uk-nav uk-dropdown-nav">
                  <li @click="sortOrder('name', 'asc')">
                    <a href="javascript:void(0)">{{ $t("sorting.a_z") }}</a>
                  </li>
                  <li @click="sortOrder('name', 'desc')">
                    <a href="javascript:void(0)">{{ $t("sorting.z_a") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'asc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_asc") }}</a>
                  </li>
                  <li @click="sortOrder('created_at', 'desc')">
                    <a href="javascript:void(0)">
                      {{ $t("sorting.created_at_desc") }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Table -->
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
              <tr>
                <th scope="col">{{ $t("survey.name") }}</th>
                <th scope="col">{{ $t("general.added_at") }}</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody class="list">
              <!--user item-->
              <tr v-for="survey in surveys">
                <td>
                  <template v-if="survey.is_default">
                    <span class="name h6 mb-0 text-sm">
                      {{ survey.name }}
                    </span>
                    <i class="uil-check-circle" :uk-tooltip="$t('survey.default_description')" title=""
                      aria-expanded="false"></i>
                  </template>
                  <router-link :to="{
                    name: 'company.survey.edit',
                    params: { id: survey.id },
                  }" class="name h6 mb-0 text-sm" v-else>
                    {{ survey.name }}
                  </router-link>
                </td>
                <td>{{ survey.created_at }}</td>
                <td class="text-right">
                  <!-- Actions -->
                  <div class="actions ml-3">
                    <router-link v-if="$hasPermission('create_assignment')" from="survey" :to="{
                      name: 'company.assignments.add',
                      params: { id: survey.content_id, title: survey.name, name: $t('general.survey') }
                    }">
                      <button class="btn btn-default small" type="button" aria-expanded="false">
                        <i class="uil-location-arrow"></i>
                        {{ $t('menu.company_dashboard.create_assignment') }}
                      </button>
                    </router-link>

                    <button v-else class="btn btn-default small" type="button" aria-expanded="false" disabled
                      :style="{ cursor: 'not-allowed' }" :uk-tooltip="$t('general.no_permission')">
                      <i class="uil-location-arrow"></i>
                      {{ $t('menu.company_dashboard.create_assignment') }}
                    </button>


                    <a class="btn btn-icon btn-hover btn-sm btn-circle" href="javascript:void(0)"
                      :uk-tooltip="$t('general.view')" @click="showItem(survey)">
                      <i class="uil-eye"></i>
                    </a>

                    <a :uk-tooltip="$t('general.survey_export_excell')" class="btn btn-icon btn-hover  btn-circle" href="javascript:;"
                      @click="exportSurveyQuestions(survey)">
                      <i class="uil uil-file-alt"></i>  
                    </a>

                    <router-link class="btn btn-icon btn-hover btn-sm btn-circle"
                      :class="survey.is_default ? 'disabled' : ''" :to="{
                        name: 'company.survey.edit',
                        params: { id: survey.id },
                      }" :uk-tooltip="$t('general.edit')" title="" aria-expanded="false">
                      <i class="uil-edit"></i>
                    </router-link>
                    <a :disabled="!$hasPermission('delete_survey')"
                      :style="{ cursor: !$hasPermission('delete_survey') ? 'not-allowed' : 'pointer' }"
                      href="javascript:void(0)" class="btn btn-icon btn-hover btn-sm btn-circle"
                      :class="survey.is_default ? 'disabled' : ''" :uk-tooltip="$t('general.delete')" title=""
                      aria-expanded="false" @click="removeItem(survey.id, survey.usage_status)">
                      <i class="uil-trash text-danger"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <pagination v-if="pagination && pagination.hasOwnProperty('links')" :pagination="pagination"
            @changePage="setPage($event)"></pagination>
        </div>
      </div>
    </div>

    <AppModal :visible.sync="showPreviewModal" :title="survey_name" maxHeight="80vh" width="700px">
      <QuestionList :hideSubmit="true" :modal_name="''" :modal_title="survey_name" :survey="survey_item"
        @onClose="showPreviewModal = false">
      </QuestionList>
    </AppModal>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/core/services";
import moment from "moment";
import module, {
  BASE_URL,
  GET_ITEMS,
  MODULE_NAME,
  ITEMS,
  ERROR,
  DELETE_ITEM,
} from "@/core/services/store/survey.module";
import Pagination from "@/assets/components/Pagination";
import QuestionList from "@/view/components/survey/QuestionList";
import AppModal from "@/view/components/ui/AppModal.vue";
import { confirmDialogDelete } from "@/utils/confirmDialog";
import axios from "axios";

export default {
  name: "SurveysList",
  components: { AppModal, Pagination, QuestionList },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(MODULE_NAME, module);
  },
  data() {
    return {
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      filter: {
        search: null,
        order: "desc",
        sort: "id",
      },
      survey_item: {},
      survey_name: null,
      showPreviewModal: false,
    };
  },
  computed: {
    items: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEMS];
      },
      set(value) { },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) { },
    },
    surveys() {
      let results = [];
      if (this.items === null || !("data" in this.items)) return [];
      this.pagination = this.items;

      for (let i = 0; i < this.items.data.length; i++) {
        let currentItem = this.items.data[i];
        if (currentItem) {
          results.push({
            id: currentItem.id,
            content_id: currentItem.content_id,
            name: currentItem.name,
            questions: currentItem.questions,
            is_default: currentItem.is_default == true ? true : false,
            status_id: currentItem.status_id,
            usage_status: currentItem.assignments.length > 0 ? true : false,
            created_at: currentItem.created_at
              ? moment(currentItem.created_at).format("DD/MM/YYYY HH:mm:ss")
              : "-",
          });
        }
      }
      return results;
    },
  },
  methods: {
    showItem(survey) {
      this.survey_item = survey;
      this.survey_name = survey.name;
      this.showPreviewModal = true;
    },
    exportSurveyQuestions(survey) {
      const surveyId = survey?.id;
      if (!surveyId) {
        return;
      }
      axios
        .get(
          process.env.VUE_APP_BACKEND_APP_URL +
            `/api/surveys/${surveyId}/questions-excel`,
          {
            params: { time: Date.now() },
            responseType: "blob",
            headers: this.apiHeaders,
          }
        )
        .then((response) => {
          let fileURL = window.URL.createObjectURL(new Blob([response.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          let day = moment().format("YYYYMMDDHHmmss");
          let fileName = `survey_questions_${surveyId}_${day}.xlsx`;
          fileLink.setAttribute("download", fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
    },
    filterResult() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: {
          like: this.filter.search,
          page: this.page,
          per_page: this.per_page,
          order: this.filter.order,
          sort: this.filter.sort,
        },
      });
    },
    async removeItem(id, usage_status) {
      if (usage_status) {
        this.errorMessages.push(
          this.$t("general.survey_in_use_cannot_delete")
        );
        return false;
      }

      const isConfirmed = await confirmDialogDelete({ context: this });

      if (isConfirmed) {
        this.$store
          .dispatch(MODULE_NAME + "/" + DELETE_ITEM, {
            url: BASE_URL + "/" + id,
          })
          .then(() => {
            if (!this.error) {
              this.successMessage = this.$t("general.successfully_deleted");
              this.filterResult();
            } else this.errorMessages.push(this.error);
          });
      }
    },
    sortOrder(sort, order) {
      let self = this;
      self.page = 1;
      self.filter.sort = sort;
      self.filter.order = order;
      this.filterResult();
    },
    setPage(page) {
      let self = this;
      self.page = page;
      this.filterResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  watch: {
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
  },
  mounted() {
    this.filterResult();
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}
</style>
